/* global google */
import React, { Component } from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import marker from '../../../../../images/marker-latinad.png';

import { withThemeMapStyles } from '../../../../../themes/mapTheme';
const MapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `344px`, borderRadius: '12px' }} />,
    mapElement: <div style={{ height: `100%`, borderRadius: '12px' }} />
  }),
  withScriptjs,
  withGoogleMap
)(
  class InnerMap extends Component {
    mapRef = null;
    boundsFitted = false;

    handleMapMount = map => {
      this.mapRef = map;
      this.fitMapToBounds();
    };

    componentDidUpdate() {
      this.fitMapToBounds();
    }

    fitMapToBounds = () => {
      const { displays } = this.props;
      if (this.mapRef && displays && displays.length > 0 && !this.boundsFitted) {
        const bounds = new google.maps.LatLngBounds();
        displays.forEach(display => {
          bounds.extend(
            new google.maps.LatLng(
              parseFloat(display.display_latitude),
              parseFloat(display.display_longitude)
            )
          );
        });
        this.mapRef.fitBounds(bounds, 50);
        this.boundsFitted = true;
      }
    };

    render() {
      const { displays } = this.props;
      return (
        <GoogleMap
          ref={this.handleMapMount}
          defaultZoom={5}
          defaultCenter={{ lat: -24, lng: -65 }}
          options={{
            clickableIcons: false,
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: false,
            styles: withThemeMapStyles([
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'transit',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }]
              },
              {
                featureType: 'road',
                elementType: 'labels.icon',
                stylers: [{ visibility: 'off' }]
              }
            ])
          }}
        >
          {displays &&
            displays.map(display => (
              <Marker
                key={display.id}
                position={{
                  lat: parseFloat(display.display_latitude),
                  lng: parseFloat(display.display_longitude)
                }}
                icon={{
                  url: marker,
                  scaledSize: new google.maps.Size(30, 30)
                }}
              />
            ))}
        </GoogleMap>
      );
    }
  }
);

export default MapComponent;
